import Vue from 'vue'
import {COMPLAINTS_URL} from 'js/lib/info.js'
import {mapGetters} from 'vuex'

import template from './index.pug'
import LoginForm from 'js/components/layout-menu/_login-form.js'

const ComplaintsBook = require('../../../assets/images/ilustrations/home/complaints-book.svg')

// @vue/component
export default Vue.extend({
  template: template(),
  components: {
    LoginForm
  },

  data() {
    return {
      complaintsUrl: COMPLAINTS_URL,
      complaintsBook: ComplaintsBook,
      showModal: false,
      step: 'login',
      showPanel: false,
    }
  },

  computed: {
    ...mapGetters(['currentUser'])
  },

  methods: {
    handleClick() {
      if (this.currentUser) {
        this.$router.push({
          name: 'municipality-service-channel'
        })
      } else {
        this.showModal = true;
      }
    },

    closeMenu() {
      this.$emit('close-menu')
    },

    login() {
      this.changeStep('login')
      this.showPanel = true
      this.showModal = false
    },

    changeStep(step) {
      this.step = step
    },

    closePanel() {
      this.showPanel = false
    },
  }
})
